import { InfiniteData, infiniteQueryOptions, UseInfiniteQueryOptions } from "@tanstack/react-query";
import { Annotation, Build, CursorPaginated } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";

export const allAnnotationsQueryKey = (buildId: Build["id"]) => {
  return ["build", buildId, "annotations", "all"];
};

type AllAnnotationsPage = CursorPaginated<Annotation>;
type AllAnnotationsPageParam = string | null;
type AllAnnotationsQueryKey = ReturnType<typeof allAnnotationsQueryKey>;

type AdditionalOptions = Omit<
  UseInfiniteQueryOptions<
    AllAnnotationsPage,
    Error,
    InfiniteData<AllAnnotationsPage, AllAnnotationsPageParam>,
    AllAnnotationsQueryKey,
    AllAnnotationsPageParam
  >,
  "queryKey" | "queryFn" | "initialPageParam" | "getNextPageParam"
>;

export const allAnnotationsQueryOptions = (build: Build, options?: AdditionalOptions) => {
  return infiniteQueryOptions({
    ...options,
    queryKey: allAnnotationsQueryKey(build.id),
    queryFn: ({ pageParam, signal }) =>
      fetchAllAnnotations(build.buildDataBasePath, pageParam, signal),
    initialPageParam: null as AllAnnotationsPageParam,
    getNextPageParam: (lastPage) => (lastPage.hasNextPage ? lastPage.endCursor : null),
  });
};

function fetchAllAnnotations(
  buildDataBasePath: Build["buildDataBasePath"],
  pageParam: string | null,
  signal: AbortSignal,
) {
  const url = new URL(`${buildDataBasePath}/annotations`, window.location.origin);

  if (pageParam) {
    url.searchParams.set("after", pageParam);
  }

  return fetcher<CursorPaginated<Annotation>>(url, true, { signal });
}
